import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-16 md:py-24 px-4 bg-black text-center overflow-hidden space-y-[0px]" data-id="element-175">
      <div className="max-w-2xl mx-auto md:space-y-32 space-y-[0px]" data-id="element-176">
        {/* 1. BLOQUE ASPIRACIONAL */}
        <div className="space-y-6 md:space-y-8 mb-[20px]" data-id="element-177">
          <p className="text-gray-400 text-lg md:text-xl font-medium tracking-wide" data-id="element-178">
            Hay mujeres que dicen lo que sienten sin miedo…
          </p>
          <p className="text-white text-xl md:text-2xl font-bold leading-relaxed" data-id="element-179">
            Que <strong className="text-rosa" data-id="element-180">no se dejan manipular</strong>…
          </p>
          <p className="text-gray-400 text-lg md:text-xl font-medium tracking-wide" data-id="element-181">
            Que <strong className="text-terracota" data-id="element-182">no persiguen</strong> a
            nadie…
          </p>
        </div>

        {/* 2. CONTRASTE */}
        <div className="relative py-12 px-6 bg-gradient-to-b from-dark/50 to-transparent rounded-3xl border border-white/5 mt-[70px]" data-id="element-183">
          <h3 className="text-rosa text-2xl md:text-3xl font-black uppercase tracking-tighter mb-8" data-id="element-184">
            Y después estás vos…
          </h3>
          <div className="space-y-6 text-gray-300 text-lg md:text-xl italic leading-relaxed" data-id="element-185">
            <p data-id="element-186">revisando el celular esperando un mensaje</p>
            <p className="text-white font-semibold" data-id="element-187">
              pensando si hiciste algo mal
            </p>
          </div>
        </div>

        {/* 3. QUIEBRE */}
        <div className="py-8 mt-[50px] mb-[20px]" data-id="element-188">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-189">
            Ellas no son más <br className="md:hidden" data-id="element-190" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rosa to-terracota" data-id="element-191">
              fuertes que vos.
            </span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl" data-id="element-192">
            Solo dejaron de conformarse con lo que les hace mal.
          </p>
        </div>

        {/* 4. BAJADA EMOCIONAL */}
        <div className="space-y-8" data-id="element-193">
          <p className="text-gray-500 text-lg md:text-xl font-medium uppercase tracking-widest" data-id="element-194">
            Porque ahora mismo…
          </p>
          <div className="space-y-4 text-white text-xl md:text-2xl font-bold" data-id="element-195">
            <p data-id="element-196">sabés que no te hace bien</p>
            <p data-id="element-197">sabés que te está afectando</p>
            <p className="text-rosa text-2xl md:text-3xl mt-4" data-id="element-198">
              pero <strong className="text-white" data-id="element-199">igual volvés</strong>.
            </p>
          </div>
        </div>

        {/* 5. CIERRE */}
        <div className="pt-12 border-t border-white/10" data-id="element-200">
          <p className="text-gray-400 text-lg md:text-xl mb-4" data-id="element-201">
            Y en algún momento pensás:
          </p>
          <h4 className="text-2xl md:text-4xl font-black text-white mb-10 italic" data-id="element-202">
            “yo no quiero seguir así”
          </h4>

          <div className="flex flex-col items-center gap-4" data-id="element-203">
            <Button data-id="element-204">QUIERO CAMBIAR MI REALIDAD</Button>
            <p className="text-gray-500 text-xs uppercase tracking-widest font-bold" data-id="element-205">
              Es momento de elegirte
            </p>
          </div>
        </div>
      </div>
    </section>;
}